/* eslint-disable */
import libraries from "../arduino/libraries";

export default function init(Blockly, profile) {
  Blockly.Arduino.motor = {};
  /**************************************************************************************************************/
  Blockly.Arduino.motor_servo_move = function() {
    // Get the values selected by the user
    const pin = this.getFieldValue("PIN");
    const degress = Blockly.Arduino.valueToCode(this, "DEGREE", Blockly.Arduino.ORDER_ATOMIC);
    const delay =
      Blockly.Arduino.valueToCode(this, "DELAY_TIME", Blockly.Arduino.ORDER_ATOMIC) || "1000";
    // Push the librarie for compiler
    Blockly.Arduino.includes_.push(libraries.servo);
    // Add the code for configuration
    Blockly.Arduino.definitions_.define_servo = "#include <Servo.h>\n";
    Blockly.Arduino.definitions_["var_servo" + pin] =
      "// Create an instance for servo motor\n" + "Servo servo_" + pin + ";\n";
    Blockly.Arduino.setups_["setup_servo_" + pin] =
      "// Attach the pin selected from blockly\n" + "servo_" + pin + ".attach(" + pin + ");\n";
    // Main code generated
    return (
      "// Servomotor write angle and delay code \n" +
      ("servo_" + pin + ".write(" + degress + ");\n") +
      ("delay(" + delay + ");\n")
    );
  };
  /**************************************************************************************************************/
  Blockly.Arduino.motor_servo_move_lite = function() {
    // Get the values selected by the user
    const pin = this.getFieldValue("PIN");
    const degress = Blockly.Arduino.valueToCode(this, "DEGREE", Blockly.Arduino.ORDER_ATOMIC);
    // Push the librarie for compiler
    Blockly.Arduino.includes_.push(libraries.servo);
    // Add the code for configuration
    Blockly.Arduino.definitions_.define_servo = "#include <Servo.h>\n";
    Blockly.Arduino.definitions_["var_servo" + pin] =
        "// Create an instance for servo motor\n" + "Servo servo_" + pin + ";\n";
    Blockly.Arduino.setups_["setup_servo_" + pin] =
        "// Attach the pin selected from blockly\n" + "servo_" + pin + ".attach(" + pin + ");\n";
    // Main code generated
    return (
        "// Servomotor write angle and delay code \n" +
        ("servo_" + pin + ".write(" + degress + ");\n")
    );
  };
  /**************************************************************************************************************/
  Blockly.Arduino.motor_servo_oscillator_set = function() {

    const pin = this.getFieldValue("PIN");
    const type = this.getFieldValue("TYPE");
    const value = Blockly.Arduino.valueToCode(this, "VALUE", Blockly.Arduino.ORDER_ATOMIC);

    Blockly.Arduino.includes_.push(libraries.servo);
    Blockly.Arduino.includes_.push(libraries.servo_osc);

    Blockly.Arduino.definitions_.define_servo = "#include <ServoOsc.h>";
    Blockly.Arduino.definitions_["var_oscillator_" + pin] = "ServoOsc oscillator_" + pin + ";\n";
    Blockly.Arduino.setups_["setup_oscillator_" + pin] = "oscillator_" + pin + ".attach(" + pin + ");";

    let code;

    "A" == type && (code = "oscillator_" + pin + ".setAmplitude(" + value + ");\n");
    "P" == type && (code = "oscillator_" + pin + ".setPhase(" + value + ");\n");
    "T" == type && (code = "oscillator_" + pin + ".setPeriod(" + value + ");\n");
    "O" == type && (code = "oscillator_" + pin + ".setOffset(" + value + ");\n");

    return code;
  };
  /**************************************************************************************************************/
  Blockly.Arduino.motor_servo_oscillator_set_lite = function() {

    const pin = this.getFieldValue("PIN");
    const type = this.getFieldValue("TYPE");
    const value = Blockly.Arduino.valueToCode(this, "VALUE", Blockly.Arduino.ORDER_ATOMIC);

    Blockly.Arduino.includes_.push(libraries.servo);
    Blockly.Arduino.includes_.push(libraries.servo_osc);

    Blockly.Arduino.definitions_.define_servo = "#include <ServoOsc.h>";
    Blockly.Arduino.definitions_["var_oscillator_" + pin] = "ServoOsc oscillator_" + pin + ";\n";
    Blockly.Arduino.setups_["setup_oscillator_" + pin] = "oscillator_" + pin + ".attach(" + pin + ");";

    let code;

    "A" == type && (code = "oscillator_" + pin + ".setAmplitude(" + value + ");\n");
    "P" == type && (code = "oscillator_" + pin + ".setPhase(" + value + ");\n");
    "T" == type && (code = "oscillator_" + pin + ".setPeriod(" + value + ");\n");
    "O" == type && (code = "oscillator_" + pin + ".setOffset(" + value + ");\n");

    return code;
  };
  /**************************************************************************************************************/
  Blockly.Arduino.motor_servo_oscillator_action = function() {
    const pin = this.getFieldValue("PIN");
    const type = this.getFieldValue("TYPE");

    Blockly.Arduino.definitions_.define_servo = "#include <ServoOsc.h>";
    Blockly.Arduino.definitions_["var_oscillator_" + pin] = "ServoOsc oscillator_" + pin + ";\n";
    Blockly.Arduino.setups_["setup_oscillator_" + pin] = "oscillator_" + pin + ".attach(" + pin + ");";

    if (type == "UPDATE") return ("oscillator_" + pin + ".update();\n");
    if (type == "START") return ("oscillator_" + pin + ".start();\n");
    if (type == "STOP" ) return ("oscillator_" + pin + ".stop();\n");
    if (type == "RESET") return ("oscillator_" + pin + ".resetToStart();\n");
  };
  /**************************************************************************************************************/
  Blockly.Arduino.motor_servo_oscillator_action_lite = function() {
    const pin = this.getFieldValue("PIN");
    const type = this.getFieldValue("TYPE");

    Blockly.Arduino.definitions_.define_servo = "#include <ServoOsc.h>";
    Blockly.Arduino.definitions_["var_oscillator_" + pin] = "ServoOsc oscillator_" + pin + ";\n";
    Blockly.Arduino.setups_["setup_oscillator_" + pin] = "oscillator_" + pin + ".attach(" + pin + ");";

    if (type == "UPDATE") return ("oscillator_" + pin + ".update();\n");
    if (type == "START") return ("oscillator_" + pin + ".start();\n");
    if (type == "STOP" ) return ("oscillator_" + pin + ".stop();\n");
    if (type == "RESET") return ("oscillator_" + pin + ".resetToStart();\n");
  };
  /**************************************************************************************************************/
  Blockly.Arduino.motor_stepper_init = function() {
    // Get the values selected by the user
    const id = this.getFieldValue("ID");
    const pin1 = this.getFieldValue("PIN1");
    const pin2 = this.getFieldValue("PIN2");
    const pin3 = this.getFieldValue("PIN3");
    const pin4 = this.getFieldValue("PIN4");
    const steps = Blockly.Arduino.valueToCode(this, "STEPS", Blockly.Arduino.ORDER_ATOMIC);

    // Push the librarie for compiler
    Blockly.Arduino.includes_.push(libraries.stepper);
    // Add the code for configuration
    Blockly.Arduino.definitions_.define_stepper = "#include <Stepper.h>\n";
    Blockly.Arduino.definitions_["var_stepper" + id] =
      "// Configure the stepper with selected values\n" +
      "Stepper stepper_" +
      (id + "(" + steps + "," + pin1 + "," + pin3 + "," + pin2 + "," + pin4 + ");\n");

    return "";
  };
  /**************************************************************************************************************/
  Blockly.Arduino.motor_stepper_setspeed = function() {
    const id = this.getFieldValue("ID");
    const speed = Blockly.Arduino.valueToCode(this, "RPM", Blockly.Arduino.ORDER_ATOMIC);

    return (
      "// Configure the selected speed for the stepper\n" +
      ("stepper_" + id + ".setSpeed(" + speed + ");\n")
    );
  };
  /**************************************************************************************************************/
  Blockly.Arduino.motor_stepper_step = function() {
    const id = this.getFieldValue("ID");
    const step = Blockly.Arduino.valueToCode(this, "STEP", Blockly.Arduino.ORDER_ATOMIC);

    return "// Moving motor with configured steps\n" + ("stepper_" + id + ".step(" + step + ");\n");
  };

  
  /**************************************************************************************************************/

  Blockly.Arduino.motor_dc_init = function() {
    const id = this.getFieldValue("ID");
    const pinA = this.getFieldValue("PIN_A");
    const pinB = this.getFieldValue("PIN_B");
    Blockly.Arduino.definitions_["define_motor_dc" + id] =
      "// Configure the DC Motor with selected values\n" +
      "#define MOTOR"+id+"A "+pinA+"\n"+
      "#define MOTOR"+id+"B "+pinB+"\n";

      Blockly.Arduino.setups_["setup_motor_dc" + id] =
        "// Motor DC pinMode\n" +
        "pinMode(MOTOR"+id+"A, OUTPUT);\n"+
        "pinMode(MOTOR"+id+"B, OUTPUT);\n";

    return (
      ""
    );
  };

  /**************************************************************************************************************/

  Blockly.Arduino.motor_dc_direction = function() {
    const id = this.getFieldValue("ID");
    const dir = this.getFieldValue("DIRECCION");
    const vel = Blockly.Arduino.valueToCode(this, "VELOCIDAD", Blockly.Arduino.ORDER_ATOMIC);

    if (dir == "1") return ("" + 
      "analogWrite(MOTOR" + id + "A, " + vel + ");\n" +
      "analogWrite(MOTOR" + id + "B, " + 0 + ");\n"
    );
    if (dir == "-1") return ("" + 
      "analogWrite(MOTOR" + id + "A, " + 0 + ");\n" +
      "analogWrite(MOTOR" + id + "B, " + vel + ");\n"
    );
  };

  Blockly.Arduino.motor_dc_stop = function() {
    const id = this.getFieldValue("ID");

    return ("" + 
      "analogWrite(MOTOR" + id + "A, " + 0 + ");\n" +
      "analogWrite(MOTOR" + id + "B, " + 0 + ");\n"
    );
  };
}
